function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function _sliced_to_array(arr, i) {
    return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
import { Button, TapTheme } from '@tapresearch/ui/components';
import { AlertDialog, AlertDialogBody, AlertDialogFooter, AlertDialogHeader, AlertDialogContent, AlertDialogOverlay, Button as ChakraButton } from '@chakra-ui/react';
import React from 'react';
import { popupContext } from '../PopupProvider';
export function ConfirmationPopup(_param) {
    var _param_title = _param.title, title = _param_title === void 0 ? 'Are you sure?' : _param_title, _param_description = _param.description, description = _param_description === void 0 ? '' : _param_description, _param_confirmationButtonText = _param.confirmationButtonText, confirmationButtonText = _param_confirmationButtonText === void 0 ? 'Accept' : _param_confirmationButtonText, _param_confirmationButtonLoadingText = _param.confirmationButtonLoadingText, confirmationButtonLoadingText = _param_confirmationButtonLoadingText === void 0 ? 'Submitting' : _param_confirmationButtonLoadingText, _param_cancelButtonText = _param.cancelButtonText, cancelButtonText = _param_cancelButtonText === void 0 ? 'Cancel' : _param_cancelButtonText, _param_onConfirm = _param.onConfirm, onConfirm = _param_onConfirm === void 0 ? Function : _param_onConfirm, _param_onCancel = _param.onCancel, onCancel = _param_onCancel === void 0 ? Function : _param_onCancel, requestState = _param.requestState, _param_contentBoxProps = _param.contentBoxProps, contentBoxProps = _param_contentBoxProps === void 0 ? {} : _param_contentBoxProps, alertDialogProps = _object_without_properties(_param, [
        "title",
        "description",
        "confirmationButtonText",
        "confirmationButtonLoadingText",
        "cancelButtonText",
        "onConfirm",
        "onCancel",
        "requestState",
        "contentBoxProps"
    ]);
    var cancelRef = React.useRef();
    var _React_useState = _sliced_to_array(React.useState(true), 2), isOpen = _React_useState[0], setIsOpen = _React_useState[1];
    var onClose = React.useCallback(function() {
        return setIsOpen(false);
    }, [
        setIsOpen
    ]);
    var resetPopup = React.useContext(popupContext).resetPopup;
    React.useLayoutEffect(function() {
        if (isOpen === false) {
            setTimeout(function() {
                return resetPopup();
            }, 600);
        }
    }, [
        isOpen,
        resetPopup
    ]);
    var onCancelClick = React.useCallback(function() {
        onCancel();
        onClose();
    }, [
        onClose,
        onCancel
    ]);
    var onConfirmationclick = React.useCallback(function() {
        onConfirm();
        if (requestState === undefined) {
            onClose();
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        requestState === null || requestState === void 0 ? void 0 : requestState.status,
        onClose
    ]);
    React.useEffect(function() {
        if (requestState === null || requestState === void 0 ? void 0 : requestState.isSuccess) {
            onConfirm();
            onClose();
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        requestState === null || requestState === void 0 ? void 0 : requestState.status,
        onClose
    ]);
    var isLoading = React.useMemo(function() {
        return !!requestState && requestState.isLoading;
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        requestState === null || requestState === void 0 ? void 0 : requestState.status
    ]);
    return /*#__PURE__*/ React.createElement(AlertDialog, _object_spread_props(_object_spread({}, alertDialogProps), {
        isOpen: isOpen,
        leastDestructiveRef: cancelRef,
        onClose: onCancelClick
    }), /*#__PURE__*/ React.createElement(AlertDialogOverlay, null, /*#__PURE__*/ React.createElement(AlertDialogContent, contentBoxProps, /*#__PURE__*/ React.createElement(AlertDialogHeader, {
        "data-testid": "confirmation-popup-title",
        fontSize: "lg",
        fontWeight: "bold"
    }, title), /*#__PURE__*/ React.createElement(AlertDialogBody, null, description), /*#__PURE__*/ React.createElement(AlertDialogFooter, null, /*#__PURE__*/ React.createElement(ChakraButton, {
        "data-testid": "confirmation-popup-cancel",
        ref: cancelRef,
        onClick: onCancelClick
    }, cancelButtonText), /*#__PURE__*/ React.createElement(Button, {
        minW: "160px",
        isLoading: isLoading,
        loadingText: confirmationButtonLoadingText,
        onClick: onConfirmationclick,
        ml: 3,
        backgroundColor: TapTheme.colors.blue[500],
        color: TapTheme.colors.white,
        _hover: {
            backgroundColor: TapTheme.colors.blue[300]
        }
    }, confirmationButtonText)))));
}
